import { Injectable } from '@angular/core';
import { IAbstractPresenter } from '@core/interfaces';
import { IScrollContainerComponent, IScrollContainerPresenter } from './interfaces';
import { ScrollDirectionEnum, ScrollDirectionEnumValues, ScrollSizeEnum, ScrollSizeEnumValues } from './enums';

@Injectable()
export class ScrollContainerPresenter
  extends IAbstractPresenter<IScrollContainerComponent>
  implements IScrollContainerPresenter
{
  direction: ScrollDirectionEnumValues = ScrollDirectionEnum.VERTICAL;
  size: ScrollSizeEnumValues = ScrollSizeEnum.AUTO;
  showScrollable: boolean = true;

  constructor() {
    super();
  }

  dispatchActions(): void {}

  suscribeObservers(): void {}
}
